import { render, staticRenderFns } from "./CourtArbitrationDetail.vue?vue&type=template&id=2086142b&scoped=true&"
import script from "./CourtArbitrationDetail.vue?vue&type=script&lang=js&"
export * from "./CourtArbitrationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2086142b",
  null
  
)

export default component.exports